import { Swiper } from 'swiper';
import {Pagination, Autoplay} from "swiper/modules";
Swiper.use([Pagination, Autoplay]);

export default () => {
    const nodeSelectors = {
        container: '[js-product-slider="container"]',
        slider: '[js-product-slider="slider"]',
        pagination: '[js-product-slider="pagination"]',
        prev: '[js-product-slider="prev"]',
        next: '[js-product-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 25,
                loop: true,
                speed: 500,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                breakpoints: {
                    // 640: {
                    //     slidesPerView: 1,
                    //     spaceBetween: 15,
                    // },    
                    // 768: {
                    //     slidesPerView: 2,
                    //     spaceBetween: 20,
                    // },
                    // 1025: {
                    //     slidesPerView: 3,
                    //     spaceBetween: 25,
                    // },
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}